/*
 * PetalPal bundle selector — widget (v1)
 * ======================================
 * Production port of the Tyler-approved prototype (110 iterations; the
 * artifact is the design spec). Replaces the Kaching Bundles widget between
 * "Offer ends soon" and the buy buttons on bouquet PDPs.
 *
 * PRINCIPLES CARRIED FROM THE SPEC (all Tyler-locked):
 *  · Honest everywhere: the button prices ONLY what's actually chosen; the
 *    tier ladder comes from the same nightly metafield checkout's discounts
 *    are synced into; delivery money renders only when its currency matches.
 *  · Psychology, truth-only: goal-gradient scoreboard with earned/locked
 *    chips, count-up ticker, ink jackpot at ladder completion, near-miss
 *    dollar distance to free delivery, loss-naming removal guard,
 *    "1 spot left" open-loop copy, post-add "Popular choice ✓" validation.
 *    No countdowns, no variable rewards, no fake anything.
 *  · Social chips carry CONCRETE data or nothing: live counter → numbered
 *    recipient → occasion breadth; every source degrades gracefully when the
 *    (optional) social feed is absent.
 *  · A/B: deterministic 50/50 between B1 (stacked tiers + inline design
 *    list) and B2 (tier radios + selection carousel); forced via
 *    ?pp-bundle-variant=b1|b2.
 *
 * BUG HISTORY BAKED IN (each cost a debugging round on the prototype):
 *  · classList.toggle, never className overwrite — a wipe killed live hooks.
 *  · Custom glide() tween — native smooth scroll silently no-ops on
 *    scroll-snap containers.
 *  · Query nested zones via retained references, not fresh selectors —
 *    innerHTML='' detaches them mid-render.
 *  · Capture rail scrollLeft BEFORE teardown, restore after re-parenting.
 *  · Position the quickview pager synchronously (forced reflow) — an rAF
 *    raced the shopper's first arrow tap.
 *  · Never overflow:hidden on a tooltip's host — clip the inner chip only.
 */
(function (w, d) {
  'use strict';

  var cfgEl = d.getElementById('pp-bundle-config');
  var host = d.getElementById('pp-bundle');
  if (!cfgEl || !host) return;
  var CFG;
  try { CFG = JSON.parse(cfgEl.textContent); } catch (e) { return; }

  /* ── dark-launch gate ─────────────────────────────────────────────
     Inert until pippy.bundle_config.enabled, EXCEPT for a developer who
     arrived with ?pp-bundle=1 once (persisted per-browser; ?pp-bundle=0
     clears). Lets the widget be verified on the LIVE theme invisibly. */
  var dev = false;
  try {
    if (/[?&]pp-bundle=0\b/.test(location.search)) localStorage.removeItem('ppb_dev');
    else if (/[?&]pp-bundle=1\b/.test(location.search)) localStorage.setItem('ppb_dev', '1');
    dev = localStorage.getItem('ppb_dev') === '1';
  } catch (e) {}
  if (!CFG.enabled && !dev) return;

  // ───────────────────────── data ─────────────────────────
  var designs = (CFG.designs || []).filter(function (x) { return x && x.variant_id; });
  var ANCHOR = -1;
  designs.forEach(function (x, i) { if (x.product_id === CFG.anchor.product_id) ANCHOR = i; });
  if (ANCHOR === -1 || !designs.length) return;

  /* Ladder: config rungs (already scope-filtered by Liquid) + the implicit
     single-item rung. Every piece of copy that once hardcoded 3/6 derives
     from THIS array — the mini ladder (4/8) renders with zero code change. */
  var RUNGS = (CFG.tiers || []).slice()
    .map(function (t) { return { q: Number(t.q), d: Number(t.pct) / 100 }; })
    .filter(function (t) { return t.q > 1 && t.d > 0; })
    .sort(function (a, b) { return a.q - b.q; });
  if (!RUNGS.length) return;
  var TIERS = [{ q: 1, d: 0 }].concat(RUNGS);
  var TOPQ = RUNGS[RUNGS.length - 1].q;
  /* Deepest discount on the ladder. The header used to hardcode "up to 25%";
     the moment the top rung went to 20% it was advertising a discount the
     store no longer gives. Derived, so it can never say that again. */
  var TOPD = TIERS.reduce(function (m, t) { return Math.max(m, t.d || 0); }, 0);
  function discOf(q) {
    var out = 0;
    RUNGS.forEach(function (t) { if (q >= t.q) out = t.d; });
    return out;
  }

  /* Engine order: the recs table ranks companions for this anchor; designs
     it doesn't mention keep catalogue order after the ranked ones. Anchor
     always first. Sold-out designs sink to the end of their group. */
  var byHandle = {};
  designs.forEach(function (x, i) { byHandle[x.handle] = i; });
  var ranked = ((CFG.recs || {})[String(CFG.anchor.product_id)] || [])
    .map(function (h) { return byHandle[h]; })
    .filter(function (i) { return i != null && i !== ANCHOR; });
  var rest = designs.map(function (_, i) { return i; }).filter(function (i) {
    return i !== ANCHOR && ranked.indexOf(i) === -1;
  });
  var ORDER = [ANCHOR].concat(ranked, rest);
  ORDER = ORDER.filter(function (i) { return designs[i].available; })
    .concat(ORDER.filter(function (i) { return !designs[i].available; }));
  var PAIR_TOP = ranked.slice(0, 2);   // top companions per the engine

  var SOCIAL = CFG.social || {};
  var soc = function (i) { return SOCIAL[designs[i].handle] || {}; };

  // ───────────────────────── strings ─────────────────────────
  /* Same 3-layer discipline as the cart: pippy.bundle_strings translation →
     English source. Every shopper-facing string passes through here so the
     translation run picks new keys up automatically. */
  function S(key, en) {
    var t = CFG.strings;
    return (t && typeof t[key] === 'string' && t[key]) || en;
  }
  function fill(tpl, vars) {
    return tpl.replace(/\{(\w+)\}/g, function (m, k) {
      return vars[k] != null ? String(vars[k]) : m;
    });
  }

  // ───────────────────────── money ─────────────────────────
  var moneyFmt, moneyBareFmt;
  try {
    moneyFmt = new Intl.NumberFormat(CFG.locale || 'en', {
      style: 'currency', currency: CFG.currency, currencyDisplay: 'narrowSymbol'
    });
  } catch (e) {
    moneyFmt = new Intl.NumberFormat('en', { style: 'currency', currency: CFG.currency });
  }
  moneyBareFmt = moneyFmt;
  function moneyBare(minor) { return moneyFmt.format(minor / 100); }
  function money(minor) {
    var s = moneyBare(minor);
    return CFG.currency_code_enabled ? s + ' ' + CFG.currency : s;
  }

  // ───────────────────────── delivery ─────────────────────────
  var RW = CFG.rewards || {};
  /* WHAT CHECKOUT CHARGES, not the raw converted band. Shopify Markets rounds
     a converted rate UP to the market's increment, and it is ON for 34 of our
     35 markets until 2026-08-03, when Tyler turned it off everywhere. While it
     was on, this widget quoted BELOW checkout by up to a whole currency unit
     (GB 150g: £3.10 converted vs £4.00 charged) and only Australia — already
     unrounded — ever agreed, which is why fixing AU's fx factor to the cent
     looked like it had fixed every market.

     So this is a no-op today, on purpose. It exists because the widget had no
     concept of the setting at all: if rounding is ever switched back on for any
     market, the old code would silently under-quote again and nothing would
     tell us.

     Reads the published rule rather than hardcoding it (see
     `presentment_rounding` in cart_rewards); the fallback keeps the old
     behaviour if an older metafield is still being served. Deliberately
     identical to pp-cart.js's chargedMinor() — two surfaces quoting one
     delivery charge must not carry two roundings. Idempotent, so re-applying
     it to an already-rounded figure is a no-op. */
  function chargedMinor(minor) {
    var m = Number(minor);
    if (!isFinite(m) || m <= 0) return minor;
    var rule = (RW.presentment_rounding || {})[CFG.country] || null;
    /* ABSENT DATA MEANS NO ROUNDING, never assumed rounding. Tyler turned
       roundingEnabled OFF on all 35 markets on 2026-08-03, so "no rounding" is
       both the safe default and the truth today; assuming the opposite would
       over-quote every market until the metafield refreshes. Same default as
       pp-cart.js's marketRounds(), deliberately. */
    if (!rule || !rule.enabled) return minor;
    var inc = rule.increment_minor || 100;
    var tail = rule.tail_minor != null
      ? rule.tail_minor : (CFG.currency === 'EUR' ? 95 : 0);
    var over = (((m - tail) % inc) + inc) % inc;
    return over === 0 ? m : m + (inc - over);
  }
  function bandMinor(r) {
    var pc = RW.presentment_currency;
    /* Only the CONVERTED branch is rounded: a base-currency shopper's rate was
       never converted, so Shopify never rounds it, and rounding here would
       invent a charge. */
    if (r.presentment_minor != null && pc && pc === CFG.currency) {
      return chargedMinor(r.presentment_minor);
    }
    if (r.rate_currency && r.rate_currency !== CFG.currency) return null;
    return r.price_minor;
  }
  /* Paid band for a PROSPECTIVE bundle (grams + subtotal from the current
     picks) — same matching rules as the cart's paidBandMinor. Returns null
     when no honest figure exists; callers then claim nothing. */
  function bandFor(grams, subtotalMinor) {
    var rates = RW.shipping_rates || [];
    var match = null;
    rates.forEach(function (r) {
      if (r.price_minor === 0) return;
      var amount = bandMinor(r);
      if (amount == null || amount <= 0) return;
      if (r.min_weight_g != null && grams < r.min_weight_g) return;
      if (r.max_weight_g != null && grams > r.max_weight_g) return;
      if (r.min_subtotal_minor != null && subtotalMinor < r.min_subtotal_minor) return;
      if (r.max_subtotal_minor != null && subtotalMinor > r.max_subtotal_minor) return;
      if (!match || amount < match) match = amount;
    });
    return match;
  }
  function arrivalText() {
    var e = RW.edd;
    if (!e || !e.min_days) return null;
    if (e.basis === 'default') {
      return fill(S('edd_typical', 'Typically arrives in {range} business days'), {
        range: e.max_days && e.max_days !== e.min_days
          ? e.min_days + '–' + e.max_days : String(e.min_days)
      });
    }
    var now = new Date(), start = new Date(now.getTime());
    function addBiz(from, days) {
      var d0 = new Date(from.getTime()), added = 0;
      while (added < days) {
        d0.setDate(d0.getDate() + 1);
        var wd = d0.getDay();
        if (wd !== 0 && wd !== 6) added++;
      }
      return d0;
    }
    /* min_days/max_days measure CARRIER TRANSIT — ParcelPanel's
       fulfillment_date to delivery_date — so the clock starts the day we hand
       the parcel over, not the day the order lands. Counting transit from the
       order date silently dropped the handling day and quoted arrival a full
       business day earlier than Shopify's own checkout estimate, which adds
       fulfilment time on top of the same transit figure. Fulfilment is set to
       "Next business day" in Shopify (Settings -> Shipping and delivery), so
       one business day is the handling step.

       The browser-hour cutoff that used to sit here is GONE (2026-08-04). It
       was doing the handling day's job by accident: past 2pm it pushed `start`
       forward a day, so once an explicit handling day was added the two
       stacked and an afternoon order quoted a day late (Tyler saw "Fri Aug 14
       – Wed Aug 19" at 4:30pm on 4 Aug, one day past checkout). It could never
       have matched Shopify anyway — Shopify cuts off at noon in the SHIPPING
       ORIGIN's timezone (Guangdong), this read the shopper's browser clock, so
       an Australian evening and a Guangdong afternoon disagreed by design.
       One handling business day from the order date, same as checkout. */
    var ship = addBiz(start, 1);
    var lo = addBiz(ship, e.min_days), hi = addBiz(ship, e.max_days);
    function fmt(dt) {
      try {
        return new Intl.DateTimeFormat(CFG.locale || 'en', {
          weekday: 'short', day: 'numeric', month: 'short'
        }).format(dt);
      } catch (err) { return dt.toDateString(); }
    }
    return fill(S('edd_arrives', 'Arrives {range}'), {
      range: lo.getTime() === hi.getTime() ? fmt(lo) : fmt(lo) + ' – ' + fmt(hi)
    });
  }

  // ───────────────────────── analytics ─────────────────────────
  /* pp-bundle.js executes BEFORE pp-cart-track.js (both deferred, DOM
     order), so events fired at init — bundle_view, the experiment's
     denominator — land before PPCartTrack exists. Buffer until it does. */
  var emitQ = [], emitT = null;
  function emit(name, fields, props) {
    try {
      var p = props || {};
      if (p.variant == null) p.variant = VARIANT;
      p.tier_arm = TIER_ARM;   // tier-default experiment arm (or cfg winner)
      /* MARK OUR OWN TRAFFIC. Measured 2026-08-04: 78% of the experiment's
         views and 76% of its ATCs came from EIGHT browsers averaging 95 events
         each — us, not shoppers — and the evaluator counted every row before
         auto-writing a tier default to the live store. Worse than noise: we
         force an arm when we verify, so our clicks don't spread evenly, they
         pile onto whichever arm we were checking. The flag was already being
         set (?pp-bundle=1 during the dark launch, and now any force flag) but
         only ever reached bundle_view, and even there only while the widget
         was disabled — so it was 0 on every row that mattered. */
      if (dev) p.dev = 1;
      if (w.PPCartTrack && w.PPCartTrack.emit) {
        w.PPCartTrack.emit(name, fields || null, p);
        return;
      }
      emitQ.push([name, fields || null, p]);
      if (!emitT) {
        var tries = 0;
        emitT = w.setInterval(function () {
          tries++;
          if (w.PPCartTrack && w.PPCartTrack.emit) {
            for (var qi = 0; qi < emitQ.length; qi++) {
              w.PPCartTrack.emit(emitQ[qi][0], emitQ[qi][1], emitQ[qi][2]);
            }
            emitQ = [];
          }
          if (!emitQ.length || tries > 100) { w.clearInterval(emitT); emitT = null; }
        }, 250);
      }
    } catch (e) {}
  }

  // ───────────────────────── A/B ─────────────────────────
  /* Forcing an arm is, by definition, not shopping. Persist the dev mark the
     same way ?pp-bundle=1 does so the whole session is excluded, not just the
     one pageview that carried the query string. */
  try {
    if (/[?&]pp-bundle-(variant|default)=/.test(location.search)) {
      localStorage.setItem('ppb_dev', '1');
      dev = true;
    }
  } catch (e) {}
  var forced = (location.search.match(/[?&]pp-bundle-variant=(b[12])/) || [])[1];
  var VARIANT = forced;
  if (!VARIANT) {
    if (CFG.ab_split === false) VARIANT = 'b1';
    else {
      try {
        VARIANT = localStorage.getItem('ppb_variant');
        if (VARIANT !== 'b1' && VARIANT !== 'b2') {
          VARIANT = Math.random() < 0.5 ? 'b1' : 'b2';   // assigned once, then sticky
          localStorage.setItem('ppb_variant', VARIANT);
        }
      } catch (e) { VARIANT = 'b1'; }
    }
  }
  /* Tier-default experiment: sticky d1 (single preselected) vs d3 (first
     discount rung preselected). A tier_default in bundle_config is the
     evaluator's promoted winner — it overrides and ends the experiment. */
  var TIER_CFG = CFG.tier_default === '1' || CFG.tier_default === '3'
    ? CFG.tier_default : null;
  var TIER_AB = null;
  if (!TIER_CFG) {
    var tForced = (location.search.match(/[?&]pp-bundle-default=([13])\b/) || [])[1];
    try {
      if (tForced) localStorage.setItem('ppb_tier_default', 'd' + tForced);
      TIER_AB = localStorage.getItem('ppb_tier_default');
      if (TIER_AB !== 'd1' && TIER_AB !== 'd3') {
        TIER_AB = Math.random() < 0.5 ? 'd1' : 'd3';   // assigned once, then sticky
        localStorage.setItem('ppb_tier_default', TIER_AB);
      }
    } catch (e) { TIER_AB = 'd1'; }
  }
  var TIER_ARM = TIER_CFG ? 'cfg' + TIER_CFG : TIER_AB;

  // ───────────────────────── tiny DOM helpers ─────────────────────────
  function el(tag, cls, text) {
    var n = d.createElement(tag);
    if (cls) n.className = cls;
    if (text != null) n.textContent = text;
    return n;
  }
  function isPhone() { return w.innerWidth < 750; }
  /* suppress all tooltips briefly around a re-render — see the .notips CSS */
  function muteTips() {
    host.classList.add('notips');
    clearTimeout(host._tipT);
    host._tipT = w.setTimeout(function () { host.classList.remove('notips'); }, 450);
  }

  /* Custom scroll tween — native behavior:'smooth' silently no-ops on
     scroll-snap containers, and rAF starves in occluded tabs, so a plain
     interval drives it. */
  function glide(elm, to, ms, onDone) {
    var from = elm.scrollLeft, t0 = Date.now();
    clearInterval(elm._glide);
    /* mandatory snap re-snaps on EVERY programmatic scrollLeft write, so the
       first tween frame yanked straight to the target (the "instant switch"
       on quickview Add — Tyler). Suspend snapping while the tween runs. */
    if (w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      elm.scrollLeft = to;
      if (onDone) onDone();
      return;
    }
    if (elm._snapSaved == null) {
      elm._snapSaved = elm.style.scrollSnapType || '';
      elm.style.scrollSnapType = 'none';
    }
    elm._glide = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / ms);
      var e = 1 - Math.pow(1 - p, 3);
      elm.scrollLeft = from + (to - from) * e;
      if (p >= 1) {
        clearInterval(elm._glide);
        elm.style.scrollSnapType = elm._snapSaved;
        elm._snapSaved = null;
        if (onDone) onDone();
      }
    }, 16);
  }

  /* Score ticker — the payout moment; the number visibly rolls up. */
  function tickMoney(elm, fromMinor, toMinor) {
    clearInterval(elm._tick);
    var reduce = false;
    try { reduce = w.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) {}
    if (reduce || Math.abs(toMinor - fromMinor) < 1) { elm.textContent = money(toMinor); return; }
    var t0 = Date.now(), dur = 450;
    elm._tick = setInterval(function () {
      var p = Math.min(1, (Date.now() - t0) / dur);
      elm.textContent = money(Math.round(fromMinor + (toMinor - fromMinor) * p));
      if (p >= 1) clearInterval(elm._tick);
    }, 40);
  }

  // ───────────────────────── shared copy pieces ─────────────────────────
  function shortName(i) { return designs[i].title.replace(/\s*Pop[- ]?Up Bouquet\s*/i, '').trim(); }
  function priceOf(i) { return designs[i].price; }
  function gramsOf(i) { return designs[i].grams || 0; }
  function sumPrices(list) { return list.reduce(function (a, i) { return a + priceOf(i); }, 0); }
  function sumGrams(list) { return list.reduce(function (a, i) { return a + gramsOf(i); }, 0); }

  /* Post-add affirmation: a green chip for a few seconds, then the row's
     normal line returns (Tyler: the permanent "Popular choice" flip never
     reverted). Copy stays truth-gated — "Popular choice" only for the
     engine's top pairs, "Loved by many" only with a real review base. */
  var AFFIRM_MS = 2000;
  var affirmAt = {};
  function noteAffirm(i) { affirmAt[i] = Date.now(); }
  function affirmRemaining(i) {
    return affirmAt[i] ? AFFIRM_MS - (Date.now() - affirmAt[i]) : 0;
  }
  function affirmChip(i) {
    if (affirmRemaining(i) <= 0) return null;
    var txt;
    if (PAIR_TOP.indexOf(i) > -1) txt = S('chip_popular', 'Popular choice ✓');
    else if ((soc(i).reviews || 0) >= 20) txt = S('affirm_loved', 'Loved by many ✓');
    else txt = S('affirm_great', 'Great choice ✓');
    return el('b', 'occhip socl won pf-affirm', txt);
  }
  /* Both states render at once and a class flip swaps them when the timer
     ends — re-rendering the whole widget for the revert made the images
     and layout visibly flash (Tyler). The normal line keeps its layout box
     (visibility, not display) so the pill-fit measurements stay valid. */
  function affirmWrap(i, normal) {
    var af = affirmChip(i);
    if (!af) return normal;
    var wr = el('span', 'pf-swap affirming');
    wr.appendChild(af);
    if (normal) wr.appendChild(normal);
    w.setTimeout(function () { wr.classList.remove('affirming'); },
                 Math.max(60, affirmRemaining(i)));
    return wr;
  }
  /* ONE chip per compact card, concrete data only, priority:
     live counter → numbered recipient → occasion breadth → nothing. */
  function socialChip(i, inBundle) {
    var s = soc(i);
    if ((s.bundles_today || 0) >= 8) return fill(S('chip_counter', 'In {n} bundles today'), { n: s.bundles_today });
    if (s.recip_label && s.recip_n) return fill(S('chip_recip', '{n} sent to {who}'), { n: s.recip_n, who: RECIP_LABEL[s.recip_label] || s.recip_label });
    /* the segment this design over-indexes in — recipient- or occasion-led,
       so neighbouring rows push DIFFERENT purchase frames (Mums / friends /
       get-wells) instead of all reciting the same occasions */
    if (s.popular_for && PF_LABEL[s.popular_for]) return PF_LABEL[s.popular_for];
    return null;
  }
  function occBreadth(i) {
    var o = soc(i).occasions;
    if (!o || !o.length) return null;
    var wrap = el('span', 'has-more');
    wrap.tabIndex = 0;
    wrap.setAttribute('role', 'button');
    wrap.setAttribute('aria-label', fill(S('a11y_occasions', 'All occasions for {name}'), { name: shortName(i) }));
    var names = o.map(occName);
    wrap.setAttribute('data-full', S('occ_loved', 'Loved for') + ': ' + names.join(', '));
    var chip = el('b', 'occhip', names.length > 1 ? names[0] + ' +' + (names.length - 1) : names[0]);
    wrap.appendChild(chip);
    return wrap;
  }
  function rowChipEl(i, inBundle) {
    var s = socialChip(i, inBundle);
    if (s) return el('b', 'occhip socl', s);
    return occBreadth(i);   // may be null — chips vanish entirely without data
  }
  /* "Loved for [Get-wells] [Daughters] [+2 more]" — plain-text label plus
     one pill per segment, trimmed post-render to whatever fits ONE line.
     Numbered chips (counter / recipient) and the post-add "Popular choice ✓"
     outrank it — concrete numbers and validation beat category claims. */
  var SEG_LABEL = {
    mums: momize(S('recip_mums', 'Mums')),
    sisters: S('seg_sisters', 'Sisters'),
    daughters: S('seg_daughters', 'Daughters'),
    friends: S('seg_friends', 'Friends'),
    /* short pill forms — the full OCC_LABEL strings are too wide for the row */
    get_well: S('seg_get_well', 'Get-wells'),
    thinking_of_you: S('seg_thinking_of_you', 'Just-because')
  };
  function segName(k) { return SEG_LABEL[k] || OCC_LABEL[k] || k; }
  function segsOf(i) {
    var s = soc(i), out = [], seen = {};
    function push(k) { if (k && !seen[k]) { seen[k] = 1; out.push(segName(k)); } }
    push(s.popular_for);
    if (s.recip_label) push(s.recip_label);
    (s.occasions || []).forEach(push);
    return out;
  }
  function pfLineEl(i, inBundle) {
    var s = soc(i);
    var normal;
    if ((s.bundles_today || 0) >= 8 || (s.recip_label && s.recip_n)) {
      normal = rowChipEl(i, inBundle);   // numbered proof keeps its slot
    } else {
      var segs = segsOf(i);
      if (!segs.length) normal = rowChipEl(i, inBundle);
      else {
        normal = el('span', 'pfline');
        normal.appendChild(el('span', 'pf-lbl', S('pf_plain', 'Loved for')));
        segs.forEach(function (t) { normal.appendChild(el('b', 'occhip socl pfp', t)); });
        var more = el('b', 'occhip socl pfmore');
        more.hidden = true;
        normal.appendChild(more);
      }
    }
    return affirmWrap(i, normal);
  }
  function fitPfLines(scope) {
    var lines = (scope || d).querySelectorAll('.pp-bundle .pfline, .pfline');
    for (var li = 0; li < lines.length; li++) {
      (function (line) {
        var pills = line.querySelectorAll('.pfp');
        var more = line.querySelector('.pfmore');
        var hidden = 0, visible = pills.length;
        for (var p = 0; p < pills.length; p++) pills[p].hidden = false;
        if (more) more.hidden = true;
        function over() { return line.scrollWidth > line.clientWidth + 1; }
        while (visible > 1 && over()) { visible--; pills[visible].hidden = true; hidden++; }
        if (hidden > 0 && more) {
          more.textContent = '+' + hidden + ' ' + S('more_word', 'more');
          more.hidden = false;
          while (visible > 1 && over()) {
            visible--; pills[visible].hidden = true; hidden++;
            more.textContent = '+' + hidden + ' ' + S('more_word', 'more');
          }
          if (over()) more.textContent = '+' + hidden;   // compact form
          if (over()) {                                   // label yields last
            var lbl = line.querySelector('.pf-lbl');
            if (lbl) lbl.hidden = true;
          }
        }
        /* tooltip on the wrapper: hover/tap the "+N more" pill reveals the
           trimmed segments */
        var host = line.parentElement;
        if (host) {
          var hiddenNames = [];
          for (var h2 = 0; h2 < pills.length; h2++) {
            if (pills[h2].hidden) hiddenNames.push(pills[h2].textContent);
          }
          if (hiddenNames.length && more && !more.hidden) {
            host.classList.add('pf-tip');
            var tipTxt = S('pf_also', 'Also loved for') + ': ' + hiddenNames.join(', ');
            host.setAttribute('data-full', tipTxt);
            more.setAttribute('role', 'button');
            more.tabIndex = 0;
            more.setAttribute('aria-label', tipTxt);
            host.style.setProperty('--ppb-tipx', more.offsetLeft + 'px');
          } else {
            host.classList.remove('pf-tip', 'open');
            host.removeAttribute('data-full');
          }
        }
      })(lines[li]);
    }
  }
  var OCC_LABEL = {
    celebration: S('occ_celebration', 'Celebrations'),
    milestone: S('occ_milestone', 'Milestones'),
    get_well: S('occ_get_well', 'Get-well gifts'),
    thinking_of_you: S('occ_thinking_of_you', 'Just-because gifts')
  };
  function occName(o) { return OCC_LABEL[o] || o; }
  /* Mum vs Mom is a MARKET fact, not a language one: US/CA English says Mom.
     Only English defaults contain "Mum", so the swap no-ops on translations. */
  var MOMIZE = CFG.country === 'US' || CFG.country === 'CA';
  function momize(str) { return MOMIZE ? str.replace(/Mums/g, 'Moms').replace(/Mum\b/g, 'Mom') : str; }
  var RECIP_LABEL = { mums: momize(S('recip_mums', 'Mums')) };
  var PF_LABEL = {
    mums: momize(S('pf_mums', 'Loved for Mums')),
    sisters: S('pf_sisters', 'Loved for Sisters'),
    daughters: S('pf_daughters', 'Loved for daughters'),
    friends: S('pf_friends', 'Loved for friends'),
    celebration: S('pf_celebration', 'Loved for celebrations'),
    milestone: S('pf_milestone', 'Loved for milestones'),
    get_well: S('pf_get_well', 'Loved for get-wells'),
    thinking_of_you: S('pf_thinking_of_you', 'Loved for just-because')
  };

  var UTAG = {
    low: S('tag_low', 'Low stock'), fast: S('tag_fast', 'Selling fast ↗'),
    new: S('tag_new', 'New'), best: S('tag_best', 'Bestseller'), pop: S('tag_pop', 'Popular pick')
  };

  // ───────────────────────── the scoreboard ─────────────────────────
  /* Money math mirrors Shopify's, which rounds the DISCOUNT per cart line
     (price × qty × pct, half-up), not the order total. Rounding the total
     showed $50.87 where checkout charges $50.88 — three $19.95 lines each
     lose $2.99, not $2.9925 (Tyler caught the cent, 2026-08-03). */
  function lineDisc(priceMinor, qty, dsc) { return Math.round(priceMinor * qty * dsc); }
  function unitNet(priceMinor, dsc) { return priceMinor - lineDisc(priceMinor, 1, dsc); }
  function picksDisc(arr, dsc) {
    if (!dsc) return 0;
    var by = {};
    arr.forEach(function (p) { by[p] = (by[p] || 0) + 1; });
    var amt = 0;
    Object.keys(by).forEach(function (k) { amt += lineDisc(priceOf(+k), by[k], dsc); });
    return amt;
  }
  function nudgeState(picksArr) {
    var count = picksArr.length;
    var gross = sumPrices(picksArr);
    var disc = discOf(count);
    var dAmt = picksDisc(picksArr, disc);
    var net = gross - dAmt;
    var freeNow = count > 0 && RW.shipping_threshold_minor != null && net >= RW.shipping_threshold_minor;
    var next = null;
    for (var k = 0; k < RUNGS.length; k++) { if (count < RUNGS[k].q) { next = RUNGS[k]; break; } }
    var wins = [];
    if (disc > 0) wins.push(Math.round(disc * 100) + '% ' + S('pct_off_word', 'off'));
    if (freeNow) wins.push(S('free_delivery', 'FREE delivery'));
    var band = bandFor(sumGrams(picksArr), net);
    var totalSave = dAmt + (freeNow && band ? band : 0);

    /* ONE dynamic opportunity-cost line — the tier cards already state the
       ladder, so the nudge names what the CURRENT selection leaves on the
       table, in dollars (Tyler 2026-08-03). */
    var table = null;

    /* THE FEE SHE STOPS PAYING, not the gap to it. "You're $9.33 from FREE
       delivery" prices the distance; it never says what the next bouquet
       actually costs once the delivery charge disappears with it. Measured on
       the live store 2026-08-04: AU's third bouquet costs $1.33 all-in, and in
       the US a FOURTH bouquet makes the order $2.41 CHEAPER than three — you
       pay less for more, which no "you're $X away" line can express.
       (Confirmed against the widget's own figures: 3 = $49.97, 4 = $47.56.)
       Tyler approved this as a separate change after the receipt so its AOV
       effect stays readable.
       Computed per market from the live band + threshold, never hardcoded: the
       AU number was 23c the day before this shipped and became $1.33 when the
       market's prices changed, so any figure written into copy is a lie
       waiting to happen. Truth-only — this states a real arithmetic
       consequence, no countdown and no invented scarcity. */
    var near = null;
    if (count > 0 && RW.shipping_threshold_minor != null) {
      var addP = priceOf(ANCHOR);
      var nowAll = net + (freeNow ? 0 : (bandFor(sumGrams(picksArr), net) || 0));
      var nextPicks = picksArr.concat([ANCHOR]);
      var nDisc = discOf(count + 1);
      var nNet = sumPrices(nextPicks) - picksDisc(nextPicks, nDisc);
      var nFree = nNet >= RW.shipping_threshold_minor;
      var nAll = nNet + (nFree ? 0 : (bandFor(sumGrams(nextPicks), nNet) || 0));
      var delta = nAll - nowAll;
      /* Only when the next bouquet is dramatically cheaper than its own price
         — otherwise this is just "things cost money" dressed as an offer. Half
         the item price is the bar; every real crossing measured so far lands
         far under it (AU $1.33 of $21.95; US -$2.41 of $13.99). */
      if (!freeNow && nFree && delta < addP * 0.5) near = { delta: delta };
    }
    if (near) {
      table = near.delta > 0
        ? fill(S('nudge_nearfree', '{amt} more unlocks FREE delivery'),
               { amt: money(near.delta) })
        : fill(S('nudge_cheaper', 'Unlock FREE delivery and save {amt}'),
               { amt: money(-near.delta) });
    } else if (count > 0 && !freeNow && RW.shipping_threshold_minor != null
               && !rungIsCloser(count, next)) {
      table = fill(S('nudge_table', 'You’re {amt} from FREE delivery'), {
        amt: money(RW.shipping_threshold_minor - net)
      });
    } else if (next) {
      var kMore = next.q - count;
      var extra = (picksDisc(picksArr, next.d) + kMore * lineDisc(priceOf(ANCHOR), 1, next.d)) - dAmt;
      if (extra > 0) {
        table = fill(S('nudge_table2', 'Going to {n} bouquets saves you {amt} more'), {
          n: next.q, amt: money(extra)
        });
      }
    }
    return {
      disc: disc, net: net, freeNow: freeNow, next: next,
      wins: wins, table: table, near: near,
      totalSave: totalSave, gold: wins.length > 0,
      complete: !next && wins.length > 0
    };
  }
  function paintNudge(nl, st, mirrorOf) {
    nl.textContent = '';
    nl.classList.toggle('gold', st.gold);
    nl.classList.toggle('jackpot', !!st.complete);
    if (st.complete && !nl._jack) {
      nl.classList.add('pop');
      clearTimeout(nl._pt);
      nl._pt = setTimeout(function () { nl.classList.remove('pop'); }, 650);
    }
    nl._jack = !!st.complete;
    if (st.complete) {
      /* the jackpot scoreboard keeps its earned-wins chips */
      nl.appendChild(el('span', 'njack', S('nudge_complete', 'Bundle complete — every reward unlocked')));
      var chips = el('span', 'nchips');
      st.wins.forEach(function (x) { chips.appendChild(el('b', 'nchip on', '✓ ' + x)); });
      nl.appendChild(chips);
    } else if (st.table) {
      var n2 = el('span', 'n2');
      n2.appendChild(d.createTextNode(st.table + ' '));
      n2.appendChild(el('i', 'uparr', '↑'));
      nl.appendChild(n2);
    }
    if (st.totalSave > 0) {
      var sc = el('span', 'nscore');
      /* One whole-sentence key split on {amt} rather than a prefix label —
         "already" has to land AFTER the money, and word order isn't ours to
         assume across 8 locales. The shaper enforces that {amt} survives
         translation, so a dropped placeholder falls back to English instead
         of shipping a sentence with the money missing. */
      var sParts = S('nudge_saved', 'You’ve saved {amt} already').split('{amt}');
      sc.appendChild(d.createTextNode(sParts[0]));
      var b = el('b');
      sc.appendChild(b);
      if (sParts.length > 1 && sParts[1]) sc.appendChild(d.createTextNode(sParts[1]));
      nl.appendChild(sc);
      tickMoney(b, nl._pv || 0, st.totalSave);
      nl._pv = st.totalSave;
    } else nl._pv = 0;
  }

  // ───────────────── loss guard (selection removals) ─────────────────
  function removalLoss(picksArr, iRemoved) {
    var count = picksArr.length;
    if (count <= 1) return null;
    var gross = sumPrices(picksArr);
    var d1 = discOf(count), disc1 = picksDisc(picksArr, d1), n1 = gross - disc1;
    var thresh = RW.shipping_threshold_minor;
    var f1 = thresh != null && n1 >= thresh;
    var after = picksArr.slice();
    after.splice(after.lastIndexOf(iRemoved), 1);
    var c2 = after.length, g2 = sumPrices(after);
    var d2 = discOf(c2), disc2 = picksDisc(after, d2), n2 = g2 - disc2;
    var f2 = thresh != null && c2 > 0 && n2 >= thresh;
    var perks = [];
    if (d2 < d1) perks.push(Math.round(d1 * 100) + '% ' + S('pct_off_word', 'off'));
    if (f1 && !f2) perks.push(S('free_delivery', 'FREE delivery'));
    if (!perks.length) return null;
    var b1c = bandFor(sumGrams(picksArr), n1), b2c = bandFor(sumGrams(after), n2);
    var amt = (disc1 + (f1 && b1c ? b1c : 0)) - (disc2 + (f2 && b2c ? b2c : 0));
    return { perks: perks, amt: amt };
  }
  var lossPop = null;
  function dismissLoss() {
    if (!lossPop) return;
    if (lossPop.parentNode) lossPop.parentNode.removeChild(lossPop);
    lossPop = null;
    d.removeEventListener('click', lossOutside, true);
  }
  function lossOutside(e) { if (lossPop && !lossPop.contains(e.target)) dismissLoss(); }
  function confirmLoss(btn, loss, proceed) {
    dismissLoss();
    var pop = el('div', 'losspop');
    pop.setAttribute('role', 'alertdialog');
    pop.appendChild(el('p', 'lp-head', S('loss_head', 'Removing this loses')));
    var chips = el('div', 'lp-chips');
    loss.perks.forEach(function (p) { chips.appendChild(el('b', 'rchip', p)); });
    pop.appendChild(chips);
    if (loss.amt > 0) pop.appendChild(el('p', 'lp-amt', '−' + money(loss.amt) + ' ' + S('loss_in_savings', 'in savings')));
    var keep = el('button', 'lp-keep', S('loss_keep', 'Keep my savings'));
    keep.type = 'button';
    keep.addEventListener('click', function () { dismissLoss(); emit('bundle_loss_guard', { kept: 1 }); });
    pop.appendChild(keep);
    var rem = el('button', 'lp-rem', S('loss_remove', 'Remove anyway'));
    rem.type = 'button';
    rem.addEventListener('click', function () { dismissLoss(); emit('bundle_loss_guard', { kept: 0 }); proceed(); });
    pop.appendChild(rem);
    host.appendChild(pop);
    lossPop = pop;
    var hr = host.getBoundingClientRect(), br = btn.getBoundingClientRect();
    var pw = pop.offsetWidth, ph = pop.offsetHeight;
    var x = Math.min(Math.max(6, br.left - hr.left + br.width / 2 - pw / 2), hr.width - pw - 6);
    var above = br.top - hr.top - ph - 12 >= 0;
    var y = above ? br.top - hr.top - ph - 12 : br.bottom - hr.top + 12;
    pop.classList.add(above ? 'is-above' : 'is-below');
    pop.style.left = x + 'px';
    pop.style.top = y + 'px';
    pop.style.setProperty('--cx', Math.min(Math.max(16, br.left - hr.left + br.width / 2 - x), pw - 16) + 'px');
    try { keep.focus(); } catch (e) {}
    setTimeout(function () { d.addEventListener('click', lossOutside, true); }, 0);
    emit('bundle_loss_guard_shown', null, { perks: loss.perks.join(' + ') });
  }

  // ───────────────────────── add to cart ─────────────────────────
  var busy = false;
  function addToCart(picks, atcBtn) {
    if (busy || !picks.length) return;
    busy = true;
    var items = picks.map(function (i) { return { id: designs[i].variant_id, quantity: 1 }; });
    // merge duplicates
    var byId = {};
    items.forEach(function (it) { byId[it.id] = (byId[it.id] || 0) + it.quantity; });
    var merged = Object.keys(byId).map(function (id) { return { id: Number(id), quantity: byId[id] }; });
    /* Request FIRST — everything else after. This handoff costs 2-3 sequential
       round trips (our add.js, then the drawer's own /cart.js, then a gift
       sync when a threshold moved), so nothing may sit in front of the one
       leg we own. Analytics used to. */
    var req = fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      credentials: 'same-origin',
      priority: 'high',
      body: JSON.stringify({ items: merged })
    });
    /* A greyed-out disabled button during a ~500ms wait reads as "it ignored
       me" — the classic cause of rage-clicks and abandons. Stay lit and keep
       moving instead; still disabled so a double-tap can't double-add. */
    var label = atcBtn.textContent;
    atcBtn.disabled = true;
    atcBtn.classList.add('busy');
    atcBtn.textContent = S('atc_busy', 'Adding…');
    // resolved now so the fallback path pays no DOM query later
    var icon = d.querySelector('.header__icon--cart, a[href$="/cart"]');
    emit('bundle_atc', {
      qty: picks.length,
      value: (sumPrices(picks) - picksDisc(picks, discOf(picks.length))) / 100,
      currency: CFG.currency
    }, { variant: VARIANT });
    req.then(function (r) {
      if (!r.ok) throw new Error('add failed ' + r.status);
      /* Call the drawer's opener directly: skips the DOM lookup, the synthetic
         click and pp-cart's header-icon interception, and gives its cart_open
         event a real reason instead of 'manual'. The peak-end savings sweep
         still fires there — that's the handoff moment. */
      if (w.PPCart && w.PPCart.open) w.PPCart.open('bundle_atc');
      else if (icon) icon.click();
      else location.href = '/cart';
    }).catch(function () {
      atcBtn.classList.add('err');
      setTimeout(function () { atcBtn.classList.remove('err'); }, 1800);
    }).then(function () {
      busy = false;
      atcBtn.disabled = false;
      atcBtn.classList.remove('busy');
      atcBtn.textContent = label;
    });
  }

  // ───────────────────────── shared lower panel ─────────────────────────
  /* Option 1B (Tyler 2026-08-03) — itemised captions + a hero total.
     The flat "2 bouquets · Total $39.90" line was two lies of omission at
     once: it called the bouquet subtotal a Total while the delivery that
     contradicts it sat BELOW the button. Two jobs, two devices — the
     caption rows make delivery a charge she can watch herself stop paying
     (loss aversion beats a "you're $X away" gap), and the total takes the
     hero slot right above the button as the price she assents to before
     the click. Delivery moves UP out of the shipnote; what's left below
     the button is the arrival promise, which is the right last beat. */
  function paintSummary(sumEl, picks, st) {
    var q = picks.length;
    sumEl.textContent = '';
    if (!q) return;
    var gross = sumPrices(picks);
    /* unconditional — at the free state this is the band she WOULD have been
       charged, which is what the strikethrough below needs. Same convention
       the tier cards and nudgeState already use for delivery-inclusive Save. */
    var band = bandFor(sumGrams(picks), st.net) || 0;
    var mini = el('div', 'sum-mini');
    function mline(cls, label, valEl) {
      var r = el('div', 'sum-l' + (cls ? ' ' + cls : ''));
      r.appendChild(el('span', null, label));
      r.appendChild(valEl);
      mini.appendChild(r);
    }
    mline('', q + ' ' + S(q === 1 ? 'bouquet_word' : 'bouquets_word', q === 1 ? 'bouquet' : 'bouquets'),
      el('span', null, moneyBare(gross)));
    if (st.disc > 0) {
      mline('save', fill(S('sum_saving', 'Bundle saving · {pct}% off'), { pct: Math.round(st.disc * 100) }),
        el('span', null, '−' + moneyBare(gross - st.net)));
    }
    var delLabel = fill(S('sum_delivery_in', 'Delivery in {country}'), { country: CFG.country_name });
    if (st.freeNow) {
      /* Strike the band she WOULD have paid (Tyler 2026-08-03): "FREE" alone
         is an adjective — next to the number it replaced it becomes a sum she
         just kept. Struck price first, FREE last: retail was/now grammar, and
         the row ends on the win. */
      var v = el('span', null);
      if (band) v.appendChild(el('s', 'sum-was', moneyBare(band)));
      v.appendChild(el('b', null, S('sum_free', 'FREE')));
      mline('free', delLabel, v);
    } else if (band) {
      mline('', delLabel, el('span', null, moneyBare(band)));
    }
    sumEl.appendChild(mini);
    var hero = el('div', 'sum-hero');
    hero.appendChild(el('span', 'sum-lbl', S('sum_total', 'Total')));
    var amt = el('span', 'sum-amt', moneyBare(st.net + (st.freeNow ? 0 : band)));
    if (CFG.currency_code_enabled) amt.appendChild(el('i', 'sum-iso', ' ' + CFG.currency));
    hero.appendChild(amt);
    sumEl.appendChild(hero);
  }
  function paintLower(zone, picks, manual) {
    var q = picks.length;
    var st = nudgeState(picks);
    paintNudge(zone.nudge, st);
    if (zone.sum) {
      paintSummary(zone.sum, picks, st);
      zone.sum.hidden = q === 0;
    }
    zone.atc.textContent = q > 0
      ? S('atc_cta', 'Add to cart')
      : S('atc_empty', 'Choose your bouquets');
    zone.atc.disabled = q === 0;
    // wiggle on upward tier crossings
    var pq = zone.atc._pq || 0;
    if (q > pq && (discOf(q) > discOf(pq))) {
      zone.atc.classList.add('wiggle');
      clearTimeout(zone.atc._wt);
      zone.atc._wt = setTimeout(function () { zone.atc.classList.remove('wiggle'); }, 600);
    }
    zone.atc._pq = q;
    /* Arrival only — the fee and the FREE flip now live in the receipt
       ABOVE the button (1B), so the last thing read before clicking is a
       promise rather than a charge. */
    var arr = arrivalText();
    zone.ship.textContent = q > 0 && arr ? arr : '';
    return st;
  }
  function buildLower(parent) {
    var nudge = el('div', 'nudgeline');
    nudge.setAttribute('aria-live', 'polite');
    var atcWrap = el('div', 'atcwrap');
    var sum = el('div', 'atc-sum');   // holds block rows now — a <p> would self-close
    sum.hidden = true;
    var atc = el('button', 'atc');
    atc.type = 'button';
    var ship = el('p', 'shipnote');
    atcWrap.appendChild(sum);
    atcWrap.appendChild(atc);
    atcWrap.appendChild(ship);
    parent.appendChild(nudge);
    parent.appendChild(atcWrap);
    return { nudge: nudge, atc: atc, ship: ship, sum: sum };
  }

  /* Phone: the moment an add crosses a discount rung, bring the delivery
     line to the bottom of the screen (ATC fully in view) and wiggle the
     button — the reward is visible at the exact moment it's earned. */
  function celebrateRung(root2, lower2, oldCount, newCount) {
    var crossed = false;
    for (var r = 0; r < RUNGS.length; r++) {
      if (oldCount < RUNGS[r].q && newCount >= RUNGS[r].q) crossed = true;
    }
    if (!crossed) return;
    w.setTimeout(function () {
      /* browse mode has its own foot; the widget-level one is display:none */
      var inQv = root2.classList.contains('qv-open');
      var ship = inQv ? root2.querySelector('.qv-foot .qv-shipnote') : lower2.ship;
      var atc = inQv ? root2.querySelector('.qv-foot .qv-atc') : lower2.atc;
      if (!ship || !atc) return;
      var smooth = !(w.matchMedia && w.matchMedia('(prefers-reduced-motion: reduce)').matches);
      try {
        /* land the delivery line right at the viewport bottom (Tyler:
           the earlier 34px clearance was a mistaken ask — flush is right) */
        var rr = ship.getBoundingClientRect();
        var delta = rr.bottom - w.innerHeight;
        if (delta > 0) w.scrollBy({ top: delta, behavior: smooth ? 'smooth' : 'auto' });
        /* late layout shifts (measured ~25px) leave the line clipped —
           re-measure once the smooth scroll settles and close the gap */
        w.setTimeout(function () {
          var r2 = ship.getBoundingClientRect();
          var d2 = r2.bottom - w.innerHeight;
          if (d2 > 2) w.scrollBy({ top: d2, behavior: 'auto' });
        }, 700);
      } catch (e) {}
      atc.classList.remove('wiggle');
      void atc.offsetWidth;
      atc.classList.add('wiggle');
      w.setTimeout(function () { atc.classList.remove('wiggle'); }, 900);
    }, 150);
  }

  // ───────────────────── tier card (shared visual) ─────────────────────
  function tierCard(t, opts) {
    // opts: {selected, count, label, normBadge, popBadge}
    var q = opts.count;
    /* The SELECTED discount card shows WHAT SHE ACTUALLY HAS, not the rung's
       nominal size (Tyler 2026-08-04). Two things were wrong before:
         - past the top rung she can keep adding, so the card read "6 bouquets"
           with 8 in the bundle, at a 6-bouquet price;
         - between rungs (4 or 5 on the 3-tier) it quoted a 3-bouquet total for
           a 4-bouquet bundle, and withheld the FREE-delivery pill she had
           already earned — on AU free delivery lands at 4, which is a count no
           card represents.
       UNSELECTED cards keep advertising their offer, because that is their job.
       The 1-tier is excluded: retitling "1 bouquet" would duplicate whichever
       discount card she is actually on. */
    /* When it is her card, price HER PICKS — not q copies of the anchor. Those
       agree only while every design in the ladder shares one price, which is
       true of AU signature today and is not a property to depend on (the
       $14.99 outlier existed until 2026-08-03, and minis are a separate ladder
       entirely). picksDisc also rounds PER LINE, which is what Shopify does and
       what a flat q x unitNet quietly does not. */
    var real = (opts.selected && t.d > 0 && opts.picks && opts.picks.length >= t.q)
      ? opts.picks : null;
    var eq = real ? real.length : t.q;
    /* Price the REAL rate at that count, not the rung's nominal one. They differ
       only if she is parked on a lower tier than her count earns (manual tier
       choice suppresses the auto-move), and in that case the true rate is the
       honest thing to show. */
    var ed = (eq === t.q) ? t.d : discOf(eq);
    var gross = real ? sumPrices(real) : eq * priceOf(ANCHOR);
    var now = real ? (gross - picksDisc(real, ed))
                   : eq * unitNet(priceOf(ANCHOR), ed);   // q lines, per-line rounding
    var free = ed > 0 && RW.shipping_threshold_minor != null && now >= RW.shipping_threshold_minor;
    var c = el('div', 'tcard' + (opts.selected ? ' sel' : '') + (t.d > 0 && q >= t.q ? ' earned' : ''));
    c.tabIndex = 0;
    c.setAttribute('role', 'radio');
    c.setAttribute('aria-checked', String(!!opts.selected));
    /* STABLE accessible name. The visible title tracks her actual count, but
       this is a role=radio: an option that renames itself while you operate it
       is hostile to screen readers, so the option keeps the rung's name and the
       count lives in the visible text only. */
    c.setAttribute('aria-label', opts.label);
    /* Badge slot does double duty. Once the card is showing her real bundle it
       must NOT still assert "MOST CUSTOMERS BUY 3" over a title reading "5
       bouquets" — that is incoherent, and it is also what made the row read as
       two competing offers rather than one bundle and one next step. Marking it
       as status is what re-separates them. */
    if (real) {
      c.appendChild(el('span', 'poptag mine', S('tier_yours', 'YOUR BUNDLE')));
    } else if (opts.badge) {
      c.appendChild(el('span', 'poptag', opts.badge));
    }
    /* Kaching-style card grammar (Tyler 2026-08-03): row 1 is title + SMALL
       inline pills + price; row 2 under the title carries the money story —
       total saving (delivery-inclusive) and the per-bouquet re-anchor. */
    var top = el('div', 't-top');
    top.appendChild(el('span', 'radio'));
    var name = el('span', 't-name');
    /* Caller's label states the rung; rebuild it when the card is showing her
       actual count instead. Same word forms, so plurals stay correct. */
    var label = (eq === t.q) ? opts.label
      : (eq + ' ' + (eq > 1 ? S('bouquets_word', 'bouquets') : S('bouquet_word', 'bouquet')));
    name.appendChild(el('span', 't-name-txt', label));
    top.appendChild(name);
    var price = el('span', 't-price');
    price.appendChild(el('span', 'now', money(now)));
    top.appendChild(price);
    c.appendChild(top);
    /* row 2: ONE shared line — per-item bundle price left under the title,
       delivery-inclusive Save right under the price */
    /* row 2: reward pills left, delivery-inclusive Save right (Tyler's final
       card grammar — line 1 stays title + price only, so nothing ever fights
       for width at any viewport). The per-item price lives on the PRODUCT
       cards instead, at the selected tier's rate. */
    var row2 = el('div', 't-row2');
    if (ed) {
      var band = free ? bandFor(real ? sumGrams(real) : gramsOf(ANCHOR) * eq, now) : null;
      var pills = el('span', 't-pills');
      pills.appendChild(el('b', 'rchip pct', Math.round(ed * 100) + '% ' + S('pct_off_word', 'off')));
      if (free) {
        pills.appendChild(el('i', 'rplus', '+'));   // both rewards come together
        pills.appendChild(el('b', 'rchip', S('free_delivery', 'FREE delivery')));
      }
      row2.appendChild(pills);
      /* Save right-aligned under the price; the ISO code hides on phones —
         it's stated on the full price directly above. Both reward pills stay
         on the TITLE line at every width (Tyler's final mobile spec). */
      var saveEl = el('span', 't-save', fill(S('tier_save', 'Save {save}'),
        { save: moneyBare(gross - now + (band || 0)) }));
      if (CFG.currency_code_enabled) saveEl.appendChild(el('i', 's-iso', ' ' + CFG.currency));
      row2.appendChild(saveEl);
    } else {
      row2.appendChild(el('span', 't-sub2 na', S('tier_standard', 'Regular price')));
    }
    c.appendChild(row2);
    return c;
  }
  /* The norm badge is a DATA CLAIM ("most customers buy N") — it renders only
     when the social feed asserts it, or for the signature ladder where the
     order data backing it was verified. Never invented for a new ladder. */
  function normBadgeFor(t) {
    if (SOCIAL && SOCIAL.norm_label) return SOCIAL.norm_label;
    if (CFG.ladder_collection === 'signature-bouquets' && t.q === RUNGS[0].q) {
      return fill(S('tier_norm', 'MOST CUSTOMERS BUY {n}'), { n: t.q });
    }
    return null;
  }

  /* The dots are a rung-filling device, so the label names the DISCOUNT rung
     they are filling toward — "just 2 more unlocks 25% off" (Tyler 2026-08-04),
     instead of only counting. Deliberate division of labour with the nudge line
     directly below: the progress label states the reward as a PERCENT, the
     nudge states delivery economics in DOLLARS. Same bundle, two different
     reasons to add one more, and neither repeats the other's sentence — which
     is the failure mode that got the old chip/locked-row nudge box replaced.
     Falls back to the plain count whenever no better rung is left to name, so
     a fully-discounted bundle never reads "unlocks 25% off" at 25% off. */
  function nextRungAfter(q) {
    var cur = discOf(q);
    for (var k = 0; k < RUNGS.length; k++) {
      if (RUNGS[k].q > q && RUNGS[k].d > cur) return RUNGS[k];
    }
    return null;
  }
  function slotLabel(q, cap, plain) {
    /* `plain` = the bare count, for surfaces that already carry the reward
       elsewhere (the quickview footer sits directly beside its own nudge
       line — repeating the rung there is clutter, not emphasis). */
    var r = plain ? null : nextRungAfter(q);
    var pct = r ? Math.round(r.d * 100) : 0;
    if (cap - q === 1) {
      /* keep the open-loop phrasing (Zeigarnik) and let it name the prize */
      return r ? fill(S('dots_one_left_reward', '1 spot left — unlocks {pct}% off'), { pct: pct })
               : S('dots_one_left', '1 spot left in your bundle');
    }
    if (q < cap) {
      return r ? fill(S('dots_progress_reward',
                        '{q} of {cap} chosen — just {n} more unlocks {pct}% off'),
                      { q: q, cap: cap, n: r.q - q, pct: pct })
               : fill(S('dots_progress', '{q} of {cap} chosen'), { q: q, cap: cap });
    }
    return fill(S('dots_full', 'Your {cap} bouquets'), { cap: cap });
  }
  /* The slot where delivery turns free — the ladder's second prize, and the one
     the TIER CARDS STRUCTURALLY CANNOT SHOW: on AU free delivery starts at 4
     but the cards are 1/3/6, so the pill only ever lands on the 6-card and the
     whole reward reads as belonging to the six-bundle (Tyler 2026-08-04).
     Projected exactly the way tierCard does — q distinct qty-1 lines at the
     rate that count earns — so the marker can never disagree with the card
     beside it. Null when no threshold is published or it falls past the dots. */
  function freeAtCount(maxN) {
    if (RW.shipping_threshold_minor == null) return null;
    var p = priceOf(ANCHOR), lim = maxN || 24;
    for (var n = 1; n <= lim; n++) {
      if (n * unitNet(p, discOf(n)) >= RW.shipping_threshold_minor) return n;
    }
    return null;
  }
  /* GOAL GRADIENT: name the prize she can actually reach next. The free-delivery
     gap used to win unconditionally, so at 2 bouquets the bar read "You're
     $28.10 AUD from FREE delivery" while she was ONE bouquet from 15% off
     (Tyler 2026-08-04). Whichever prize is fewer bouquets away wins; a tie goes
     to the discount rung, because a rung is a certain step at a known count
     while the delivery gap moves with whatever she adds.
     Entirely market-derived — RUNGS come from the ladder config and the
     threshold from cart_rewards, so a market whose free delivery lands BELOW
     its first rung (the EU shape) naturally keeps the delivery message, and a
     market where the rung is nearer naturally flips. No per-market branches. */
  function rungIsCloser(count, next) {
    if (!next) return false;
    var freeAt = freeAtCount(24);
    if (!freeAt || freeAt <= count) return false;
    return (next.q - count) <= (freeAt - count);
  }
  function slotDots(q, cap, opts) {
    /* opts.plain — bare count, no rung clause and no milestone flag. The
       quickview FOOTER needs this for a structural reason as well as a design
       one: syncFoot() moves these children into its own strip and drops the
       .slotdots wrapper, so the `.wide` and `.hasmile` classes never arrive and
       the label wraps to two rows while the absolutely-positioned flag floats
       loose under the ticks (Tyler saw exactly that). Anything that depends on
       a class on the wrapper CANNOT be used there — same trap as the old
       .qv-thsc removal: markup moved without its wiring. */
    var plain = !!(opts && opts.plain);
    var wide = !plain && q < cap && !!nextRungAfter(q);
    var shown = Math.min(cap, 12);
    var freeAt = plain ? null : freeAtCount(shown);   // only flag a visible slot
    var dots = el('div', 'slotdots' + (wide ? ' wide' : '') + (freeAt ? ' hasmile' : ''));
    for (var s2 = 0; s2 < shown; s2++) {
      var d = el('span', (s2 < q ? 'sd' : 'sd empty') + (freeAt === s2 + 1 ? ' mile' : ''));
      if (freeAt === s2 + 1) {
        /* The flag says "FREE delivery", never a bare "FREE" — under a bouquet
           slot that would read as a free BOUQUET, which we do not offer. */
        d.appendChild(el('i', 'mileflag', S('dots_free_flag', 'FREE delivery')));
        d.setAttribute('title', fill(S('dots_free_title', 'FREE delivery from {n} bouquets'),
                                     { n: freeAt }));
      }
      dots.appendChild(d);
    }
    dots.appendChild(el('span', 'lbl', slotLabel(q, cap, plain)));
    return dots;
  }

  /* Tooltip open/close for "+N" occasion chips — document-level capture so a
     chip tap never falls through to the row's add handler. */
  d.addEventListener('click', function (e) {
    var t = e.target && e.target.closest ? e.target.closest('.pp-bundle .has-more') : null;
    var openOnes = d.querySelectorAll('.pp-bundle .has-more.open');
    for (var i2 = 0; i2 < openOnes.length; i2++) {
      if (openOnes[i2] !== t) openOnes[i2].classList.remove('open');
    }
    if (t) { e.stopPropagation(); t.classList.toggle('open'); }
    /* "+N more" pill: tooltip lives on the line's WRAPPER (the fit line
       overflow-clips its own ::after) — tap toggles, tap-away closes */
    var m = e.target && e.target.closest ? e.target.closest('.pp-bundle .pfmore') : null;
    var mHost = m ? m.closest('.pf-tip') : null;
    var openTips = d.querySelectorAll('.pp-bundle .pf-tip.open');
    for (var i3 = 0; i3 < openTips.length; i3++) {
      if (openTips[i3] !== mHost) openTips[i3].classList.remove('open');
    }
    if (mHost) { e.stopPropagation(); mHost.classList.toggle('open'); }
  }, true);

  // ═══════════════════════ B1: stacked tiers + inline list ═══════════════════════
  function widgetB1(root) {
    /* default tier comes from the experiment arm (or its promoted winner) */
    var tierQ = (TIER_CFG === '3' || TIER_AB === 'd3') ? RUNGS[0].q : 1;
    var manualTier = false;
    var picks = [ANCHOR];            // the page's product is slot 1, floor of 1
    var expanded = false, dpage = 0;
    var DPAGE = 5;

    var head = el('p', 'offerhead', fill(S('offer_head', 'Buy more, save up to {pct}%'),
                                        { pct: Math.round(TOPD * 100) }));
    root.appendChild(head);
    var tiersEl = el('div', 'tiers');
    tiersEl.setAttribute('role', 'radiogroup');
    tiersEl.setAttribute('aria-label', S('a11y_tiers', 'Bundle size'));
    root.appendChild(tiersEl);
    var lower = buildLower(root);
    function eff() { return tierQ === 1 ? [ANCHOR] : picks; }
    lower.atc.addEventListener('click', function () { addToCart(eff(), lower.atc); });

    var qview = makeQuickview(root, {
      cnt: function (i) { return picks.filter(function (p) { return p === i; }).length; },
      canAdd: function () { return picks.length < 24; },
      canRemove: function (i) {
        var c = picks.filter(function (p) { return p === i; }).length;
        return c > 0 && !(i === ANCHOR && c <= 1);
      },
      onAdd: function (i) { addDesign(i); },
      onRemove: function (i, btn) {
        var loss = removalLoss(picks, i);
        if (loss && btn) confirmLoss(btn, loss, function () { removeDesign(i); qview.sync(); });
        else removeDesign(i);
      },
      progress: function () {
        var q = picks.length;
        var cap = q >= tierQ ? Math.max(TOPQ, q) : Math.max(tierQ, RUNGS[0].q);
        return { q: q, cap: cap };
      },
      nextUnitPrice: function (i) { return unitNet(priceOf(i), discOf(picks.length + 1)); },
      total: function () { return picks.length; },
      atcLabel: function () {
        return picks.length > 0 ? S('atc_cta', 'Add to cart') : S('atc_empty', 'Choose your bouquets');
      },
      onAtc: function () { addToCart(picks, lower.atc); },
      lowerHost: lower
    });

    function addDesign(i) {
      if (picks.length >= 24 || !designs[i].available) return;
      var was = picks.length;
      picks.push(i);
      /* qualify-at-the-top only: the selection auto-moves to the top rung the
         moment the count actually earns it — never sooner. */
      if (!manualTier && picks.length >= TOPQ) tierQ = TOPQ;
      emit('bundle_add', { product_id: designs[i].product_id }, { variant: VARIANT });
      noteAffirm(i);
      render();
      celebrateRung(root, lower, was, picks.length);
    }
    function removeDesign(i) {
      var at = picks.lastIndexOf(i);
      if (at === -1) return;
      if (i === ANCHOR && picks.filter(function (p) { return p === ANCHOR; }).length <= 1) return;
      picks.splice(at, 1);
      if (!manualTier && tierQ === TOPQ && picks.length < TOPQ) tierQ = RUNGS[0].q;
      render();
    }
    function setTier(q2) { tierQ = q2; manualTier = q2 !== RUNGS[0].q; render(); }

    function render() {
      muteTips();
      var q = picks.length;
      tiersEl.textContent = '';
      TIERS.forEach(function (t) {
        var selT = tierQ === t.q || (t.q === 1 && tierQ === 1);
        var c = tierCard(t, {
          selected: t.q === tierQ, count: q, picks: picks,
          label: t.q + ' ' + (t.q > 1 ? S('bouquets_word', 'bouquets') : S('bouquet_word', 'bouquet')),
          badge: t.d ? normBadgeFor(t) : null
        });
        c.addEventListener('click', function () { if (tierQ !== t.q) setTier(t.q); });
        c.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); if (tierQ !== t.q) setTier(t.q); }
        });

        if (t.q === tierQ && t.q > 1) {
          var panel = el('div', 'vpanel');
          panel.addEventListener('click', function (e) { e.stopPropagation(); });
          panel.addEventListener('keydown', function (e) { e.stopPropagation(); });
          var cap = q >= tierQ ? Math.max(TOPQ, q) : t.q;
          panel.appendChild(slotDots(q, cap));

          var full = picks.length >= 24;
          var list = el('div', 'vlist');

          // page the design list: picked designs pinned on every page
          var pinned = [], unpicked = [];
          ORDER.forEach(function (i) {
            if (picks.indexOf(i) > -1) pinned.push(i); else unpicked.push(i);
          });
          var pageCap = Math.max(1, DPAGE - pinned.length);
          var totalPages = Math.max(1, Math.ceil(unpicked.length / pageCap));
          if (dpage >= totalPages) dpage = totalPages - 1;
          var visible = expanded
            ? pinned.concat(unpicked.slice(dpage * pageCap, dpage * pageCap + pageCap))
            : pinned.concat(unpicked.slice(0, Math.max(0, 3 - pinned.length)));

          visible.forEach(function (i) {
            var cnt = picks.filter(function (p) { return p === i; }).length;
            var row = el('div', 'vrow' + (cnt > 0 ? ' in' : '') + (designs[i].available ? '' : ' oos'));
            var sw = el('span', 'sw');
            var img = el('img');
            img.loading = 'lazy';
            img.alt = shortName(i);
            img.src = designs[i].images[0] || '';
            sw.appendChild(img);
            row.appendChild(sw);
            var col = el('div', 'vcol');
            var vn = el('span', 'vn');
            if (soc(i).rating) {
              var tsp = el('b', 'occhip starpill tstar');
              tsp.appendChild(el('i', null, '★'));
              tsp.appendChild(d.createTextNode(' ' + soc(i).rating));
              vn.appendChild(tsp);
            }
            vn.appendChild(d.createTextNode(shortName(i)));   // size suffix dropped (Tyler)
            /* Desktop: TWO lines — the social pill joins the title after the
               rating, and the action sits beside a bigger each-price. Phone
               keeps the three-line stack (no room beside a 360px title). */
            var deskRow = !isPhone();
            if (deskRow && soc(i).urgency && UTAG[soc(i).urgency]) {
              vn.appendChild(el('b', 'utag inlinetag ' + soc(i).urgency, UTAG[soc(i).urgency]));
            }
            /* price rides the title line, right-aligned over the Add
               button; dynamic like the old each-price (next-add vs tier). */
            var line1 = el('span', 'vline1');
            line1.appendChild(vn);
            /* DESCRIPTIVE, never projected (Tyler 2026-08-03): the rate the
               bundle has ACTUALLY earned. Reading the selected tier's rate
               printed "$16.96" beside a "1 bouquet · Total $19.95" summary —
               two true numbers that no arithmetic reconciles, and Kaching's
               advertise-the-bundle-price flaw in miniature. The tier card
               carries the promise ($50.88 / Save $23.28); rows carry the fact,
               and all three rows flip together the moment the rung is hit. */
            var dShow = discOf(picks.length);
            line1.appendChild(el('span', 'vprice', moneyBare(unitNet(priceOf(i), dShow))));
            col.appendChild(line1);
            var pf = pfLineEl(i, cnt > 0);
            var line2 = deskRow ? el('span', 'vline2') : null;
            if (line2) {
              var l2l = el('span', 'vl2l');
              if (pf) l2l.appendChild(pf);
              line2.appendChild(l2l);
              col.appendChild(line2);
            }
            wireQuickview(sw, i);
            wireQuickview(vn, i);   // titles link to quick view too (Tyler, re-added)
            var meta = el('div', 'vmeta');
            /* phone: pills share the action line — the act controls are
               compact (28px) under 750px so the lane stays wide enough */
            if (!deskRow && pf) meta.appendChild(pf);
            var act = el('div', 'act');
            if (!designs[i].available) {
              act.appendChild(el('span', 'soldout', S('sold_out', 'Sold out')));
            } else if (cnt === 0) {
              var add = el('button', 'addv', S('add_word', 'Add'));
              add.type = 'button';
              add.disabled = full;
              add.setAttribute('aria-label', fill(S('a11y_add', 'Add {name} to your bundle'), { name: shortName(i) }));
              add.addEventListener('click', function (e) { e.stopPropagation(); addDesign(i); });
              act.appendChild(add);
            } else {
              var grp = el('div', 'stepgrp');
              var minus = el('button', null, '−');
              minus.type = 'button';
              minus.disabled = i === ANCHOR && cnt <= 1;
              minus.setAttribute('aria-label', fill(S('a11y_fewer', 'One fewer {name}'), { name: shortName(i) }));
              minus.addEventListener('click', function (e) {
                e.stopPropagation();
                var loss = removalLoss(picks, i);
                if (loss) confirmLoss(minus, loss, function () { removeDesign(i); });
                else removeDesign(i);
              });
              var nq = el('span', 'vqn', String(cnt));
              var plus = el('button', null, '+');
              plus.type = 'button';
              plus.disabled = full;
              plus.setAttribute('aria-label', fill(S('a11y_more', 'One more {name}'), { name: shortName(i) }));
              plus.addEventListener('click', function (e) { e.stopPropagation(); addDesign(i); });
              grp.appendChild(minus); grp.appendChild(nq); grp.appendChild(plus);
              act.appendChild(grp);
            }
            if (deskRow) {
              line2.appendChild(act);
            } else {
              meta.appendChild(act);
              col.appendChild(meta);
            }
            row.appendChild(col);
            list.appendChild(row);
          });
          panel.appendChild(list);

          if (!expanded) {
            if (ORDER.length > visible.length) {
              var sm = el('button', 'showmore', S('show_more', 'Show more designs ▾'));
              sm.type = 'button';
              sm.addEventListener('click', function (e) { e.stopPropagation(); expanded = true; dpage = 0; render(); });
              panel.appendChild(sm);
            }
          } else if (totalPages > 1) {
            var pager = el('div', 'pager2');
            if (dpage > 0) {
              var prev = el('button', 'showmore', '‹ ' + S('prev_designs', 'Previous designs'));
              prev.type = 'button';
              prev.addEventListener('click', function (e) { e.stopPropagation(); dpage--; render(); });
              pager.appendChild(prev);
            }
            if (dpage < totalPages - 1) {
              var nxt = el('button', 'showmore', S('next_designs', 'Next designs') + ' ›');
              nxt.type = 'button';
              nxt.addEventListener('click', function (e) { e.stopPropagation(); dpage++; render(); });
              pager.appendChild(nxt);
            }
            panel.appendChild(pager);
          }
          c.appendChild(panel);
        }
        tiersEl.appendChild(c);
      });
      paintLower(lower, eff());
      qview.syncIfOpen();
      /* fit once at paint, once after layout settles (fonts/frames), and on
         resize — a line measured mid-settle can report a phantom 30px */
      w.requestAnimationFrame(function () { fitPfLines(tiersEl); });
      w.setTimeout(function () { fitPfLines(tiersEl); }, 300);
    }
    var _pfRs;
    w.addEventListener('resize', function () {
      clearTimeout(_pfRs);
      _pfRs = setTimeout(function () { fitPfLines(tiersEl); }, 150);
    });
    function wireQuickview(elm, i) {
      elm.classList.add('qv-openable');
      elm.setAttribute('role', 'button');
      elm.tabIndex = 0;
      elm.addEventListener('click', function (e) { e.stopPropagation(); qview.open(i); });
      elm.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); e.stopPropagation(); qview.open(i); }
      });
    }
    render();
  }

  // ═══════════════════ B2: tier radios + selection carousel ═══════════════════
  function widgetB2(root) {
    var mode = 'single';           // 'single' | 'bundle'
    var goal = null;               // the rung the shopper tapped
    if (TIER_CFG === '3' || TIER_AB === 'd3') { mode = 'bundle'; goal = RUNGS[0].q; }
    var picks = [ANCHOR];

    var head = el('p', 'offerhead', fill(S('offer_head', 'Buy more, save up to {pct}%'),
                                        { pct: Math.round(TOPD * 100) }));
    root.appendChild(head);
    var tiersEl = el('div', 'tiers');
    tiersEl.setAttribute('role', 'radiogroup');
    tiersEl.setAttribute('aria-label', S('a11y_tiers', 'Bundle size'));
    root.appendChild(tiersEl);
    var lower = buildLower(root);
    lower.atc.addEventListener('click', function () {
      addToCart(mode === 'bundle' ? picks : [ANCHOR], lower.atc);
    });

    // the carousel zone lives INSIDE the selected tier card
    var bundlezone = el('div', 'bundlezone');
    var car = el('div', 'car');
    var carL = el('button', 'car-arr l', '‹'); carL.type = 'button';
    var carR = el('button', 'car-arr r', '›'); carR.type = 'button';
    var track = el('div', 'cscroll'); track.appendChild(el('span', 'thumb'));
    var bd = el('div', 'b2dots');
    bundlezone.appendChild(bd);
    var carWrap = el('div', 'carwrap');
    carWrap.appendChild(carL); carWrap.appendChild(car); carWrap.appendChild(carR);
    bundlezone.appendChild(carWrap);
    bundlezone.appendChild(track);
    bundlezone.addEventListener('click', function (e) { e.stopPropagation(); });

    var qview = makeQuickview(root, {
      cnt: cnt,
      canAdd: function () { return picks.length < 24; },
      canRemove: function (i) { var c = cnt(i); return c > 0 && picks.length > 1 && !(i === ANCHOR && c <= 1); },
      onAdd: function (i) { addOne(i); },
      onRemove: function (i, btn) {
        var loss = removalLoss(picks, i);
        if (loss && btn) confirmLoss(btn, loss, function () { removeOne(i); qview.sync(); });
        else removeOne(i);
      },
      progress: function () {
        var q = picks.length;
        var cap = q < RUNGS[0].q ? RUNGS[0].q : q < TOPQ ? TOPQ : q;
        return { q: q, cap: cap };
      },
      nextUnitPrice: function (i) { return unitNet(priceOf(i), discOf(picks.length + 1)); },
      total: function () { return picks.length; },
      atcLabel: function () {
        return picks.length > 0 ? S('atc_cta', 'Add to cart') : S('atc_empty', 'Choose your bouquets');
      },
      onAtc: function () { addToCart(picks, lower.atc); },
      lowerHost: lower
    });

    function cnt(i) { return picks.filter(function (p) { return p === i; }).length; }
    function addOne(i) {
      if (picks.length >= 24 || !designs[i].available) return;
      var was = picks.length;
      picks.push(i);
      emit('bundle_add', { product_id: designs[i].product_id }, { variant: VARIANT });
      noteAffirm(i);
      render();
      advanceRail(i);
      celebrateRung(root, lower, was, picks.length);
    }
    function removeOne(i) {
      var at = picks.lastIndexOf(i);
      if (at === -1 || picks.length <= 1) return;
      if (i === ANCHOR && cnt(ANCHOR) <= 1) return;
      picks.splice(at, 1);
      render();
    }
    function tapTier(target) {
      if (target === 1) { mode = 'single'; goal = null; }
      else { mode = 'bundle'; goal = target; }
      render();
    }

    var cardEls = [];
    function buildCards() {
      car.textContent = '';
      cardEls = [];
      ORDER.forEach(function (i) {
        var c = el('div', 'pcard' + (designs[i].available ? '' : ' oos'));
        c.tabIndex = 0;
        c.setAttribute('role', 'button');
        c.setAttribute('aria-label', fill(S('a11y_add', 'Add {name} to your bundle'), { name: shortName(i) }));
        c.appendChild(el('span', 'check', '×0'));
        var iw = el('span', 'imgwrap');
        var img = el('img');
        img.loading = 'lazy';
        img.alt = shortName(i);
        img.src = designs[i].images[0] || '';
        iw.appendChild(img);
        if (soc(i).urgency && UTAG[soc(i).urgency]) iw.appendChild(el('b', 'utag ' + soc(i).urgency, UTAG[soc(i).urgency]));
        if (soc(i).rating) {
          var ps = el('span', 'pstars');
          ps.appendChild(el('b', null, '★'));
          ps.appendChild(d.createTextNode(' ' + soc(i).rating));
          iw.appendChild(ps);
        }
        c.appendChild(iw);
        var pn2 = el('span', 'pn', shortName(i));
        c.appendChild(pn2);
        c.appendChild(el('span', 'peach2'));
        var chip = affirmWrap(i, rowChipEl(i, false));
        var psize = el('span', 'psize');
        if (chip) psize.appendChild(chip);
        c.appendChild(psize);
        c.appendChild(el('span', 'state', designs[i].available ? S('add_word', 'Add') : S('sold_out', 'Sold out')));
        var qctl = el('div', 'qctl');
        var minus = el('button', null, '−'); minus.type = 'button';
        minus.setAttribute('aria-label', fill(S('a11y_fewer', 'One fewer {name}'), { name: shortName(i) }));
        var qn = el('span', 'qn', '0');
        var plus = el('button', null, '+'); plus.type = 'button';
        plus.setAttribute('aria-label', fill(S('a11y_more', 'One more {name}'), { name: shortName(i) }));
        qctl.appendChild(minus); qctl.appendChild(qn); qctl.appendChild(plus);
        c.appendChild(qctl);
        c.addEventListener('click', function () { if (cnt(i) === 0 && designs[i].available) addOne(i); });
        c.addEventListener('keydown', function (e) {
          if ((e.key === 'Enter' || e.key === ' ') && cnt(i) === 0 && designs[i].available) { e.preventDefault(); addOne(i); }
        });
        minus.addEventListener('click', function (e) {
          e.stopPropagation();
          var loss = removalLoss(picks, i);
          if (loss) confirmLoss(minus, loss, function () { removeOne(i); });
          else removeOne(i);
        });
        plus.addEventListener('click', function (e) { e.stopPropagation(); addOne(i); });
        wireQv(iw, i);
        wireQv(c.querySelector('.pn'), i);   // titles link to quick view too (Tyler, re-added)
        cardEls[i] = c;
        car.appendChild(c);
      });
    }
    function wireQv(elm, i) {
      elm.classList.add('qv-openable');
      elm.addEventListener('click', function (e) { e.stopPropagation(); qview.open(i); });
    }
    buildCards();

    function syncCar() {
      var overflow = car.scrollWidth - car.clientWidth;
      track.hidden = overflow <= 2;
      carL.style.display = car.scrollLeft > 2 ? 'grid' : 'none';
      carR.style.display = car.scrollLeft < overflow - 2 ? 'grid' : 'none';
      if (overflow <= 2) return;
      var thumb = track.querySelector('.thumb');
      var w2 = Math.max(18, car.clientWidth / car.scrollWidth * 100);
      thumb.style.width = w2 + '%';
      thumb.style.left = (car.scrollLeft / overflow * (100 - w2)) + '%';
    }
    car.addEventListener('scroll', syncCar);
    carL.addEventListener('click', function (e) { e.stopPropagation(); glide(car, car.scrollLeft - car.clientWidth * 0.8, 300, syncCar); });
    carR.addEventListener('click', function (e) { e.stopPropagation(); glide(car, car.scrollLeft + car.clientWidth * 0.8, 300, syncCar); });
    function advanceRail(justAdded) {
      // slide to the next unadded design so the conveyor keeps offering
      for (var k = ORDER.indexOf(justAdded) + 1; k < ORDER.length; k++) {
        var idx = ORDER[k];
        if (cnt(idx) === 0 && designs[idx].available && cardEls[idx]) {
          glide(car, cardEls[idx].offsetLeft - 12, 320, syncCar);
          return;
        }
      }
    }

    function render() {
      muteTips();
      var q = picks.length;
      var railKeep = car.scrollLeft;   // captured BEFORE teardown detaches the rail
      tiersEl.textContent = '';
      var active3 = mode === 'bundle' && q < TOPQ;
      var active6 = mode === 'bundle' && q >= TOPQ;
      var rows = [{ t: TIERS[0], label: '1 ' + S('bouquet_word', 'bouquet'), active: mode === 'single', target: 1 }];
      RUNGS.forEach(function (r2, k2) {
        var isTop = k2 === RUNGS.length - 1;
        var lbl = (isTop ? r2.q : (q > r2.q && q < TOPQ && mode === 'bundle' ? q : r2.q)) + ' ' + S('bouquets_word', 'bouquets');
        rows.push({
          t: r2, label: lbl,
          active: mode === 'bundle' && (isTop ? q >= TOPQ : q < TOPQ) &&
            (RUNGS.length < 2 || isTop === (q >= TOPQ)),
          target: r2.q
        });
      });
      rows.forEach(function (r2) {
        var c = tierCard(r2.t, {
          selected: r2.active, count: q, label: r2.label,
          badge: r2.t.d ? (r2.t.q === TOPQ && RUNGS.length > 1
            ? S('tier_best', 'BEST VALUE') : normBadgeFor(r2.t)) : null
        });
        c.addEventListener('click', function () { tapTier(r2.target); });
        c.addEventListener('keydown', function (e) {
          if (e.key === 'Enter' || e.key === ' ') { e.preventDefault(); tapTier(r2.target); }
        });
        tiersEl.appendChild(c);
        if (r2.active && mode === 'bundle') {
          // ladder line above the rail
          bd.textContent = '';
          var cap = q < RUNGS[0].q ? RUNGS[0].q : q < TOPQ ? TOPQ : q;
          bd.appendChild(slotDots(q, cap));
          c.appendChild(bundlezone);
        }
      });
      designs.forEach(function (_, i) {
        if (!cardEls[i]) return;
        var n = cnt(i);
        cardEls[i].classList.toggle('in', n > 0);
        cardEls[i].setAttribute('aria-pressed', String(n > 0));
        cardEls[i].querySelector('.check').textContent = '×' + n;
        cardEls[i].querySelector('.qn').textContent = String(n);
        var dShow2 = discOf(q);   // earned rate only — same grammar as B1 rows
        cardEls[i].querySelector('.peach2').textContent =
          moneyBare(unitNet(priceOf(i), dShow2)) + ' ' + S('each_word', 'each');
        cardEls[i].querySelector('.qctl button').disabled = i === ANCHOR && n <= 1;
        var chip = affirmWrap(i, rowChipEl(i, n > 0));
        var ph = cardEls[i].querySelector('.psize');
        ph.textContent = '';
        if (chip) ph.appendChild(chip);
      });
      car.scrollLeft = railKeep;   // re-parenting reset it; restore
      if (mode === 'bundle') {
        var st = paintLower(lower, picks);
        void st;
      } else {
        paintLower(lower, [ANCHOR]);
      }
      syncCar();
      qview.syncIfOpen();
    }
    render();
  }

  // ═══════════════════════ browse mode (quick view) ═══════════════════════
  function makeQuickview(root, opts) {
    var qv = el('div', 'qv');
    qv.hidden = true;
    var panel = el('div', 'qv-panel');
    var headRow = el('div', 'qv-head');
    var backBtn = el('button', 'qv-backbtn', '‹ ' + S('qv_back', 'Back to classic view'));
    backBtn.type = 'button';
    var nav = el('div', 'qv-nav');
    var navL = el('button', 'qv-arr', '‹'); navL.type = 'button';
    var navLbl = el('span', 'qv-pos');
    var navR = el('button', 'qv-arr', '›'); navR.type = 'button';
    nav.appendChild(navL); nav.appendChild(navLbl); nav.appendChild(navR);
    headRow.appendChild(backBtn); headRow.appendChild(nav);
    panel.appendChild(headRow);
    /* Progress sits ABOVE the rail, not in the footer (Tyler 2026-08-04). Two
       reasons. Design: stacked directly on top of the nudge box it made two
       competing green blocks in a sticky footer that already carried the
       receipt and the button — four stacked blocks on an 844px phone. Meaning:
       the dots answer "how full is my bundle", which belongs beside the cards
       she is swiping, while the footer answers "what am I paying" and owns the
       CTA. Splitting them by question rather than by convenience also lets the
       strip stay slim — it carries the bare count, because the footer's nudge
       line right below is already naming the reward. */
    var footDots = el('div', 'slotdots qv-dots');
    panel.appendChild(footDots);
    var pagesEl = el('div', 'qv-pages');
    panel.appendChild(pagesEl);
    var foot = el('div', 'qv-foot');
    var footNudge = el('div', 'nudgeline qv-nudge');
    var footShip = el('p', 'shipnote qv-shipnote');
    var footSum = el('div', 'atc-sum'); footSum.hidden = true;
    var footAtc = el('button', 'atc qv-atc'); footAtc.type = 'button';
    foot.appendChild(footNudge);
    foot.appendChild(footSum); foot.appendChild(footAtc); foot.appendChild(footShip);
    panel.appendChild(foot);
    qv.appendChild(panel);
    root.appendChild(qv);

    var pageEls = {};
    var openState = false;

    function step() {
      var first = pagesEl.firstElementChild;
      if (!first) return 1;
      var gap = 8;
      return first.getBoundingClientRect().width + gap;
    }
    function pageIndex() { return Math.round(pagesEl.scrollLeft / step()); }

    function buildPages() {
      pagesEl.textContent = '';
      pageEls = {};
      ORDER.forEach(function (i) {
        var pg = el('div', 'qv-page');
        var main = el('div', 'qv-main');
        var hero = el('img', 'qv-img');
        hero.alt = shortName(i);
        hero.loading = 'lazy';
        hero.src = designs[i].images[0] || '';
        main.appendChild(hero);
        var marks = el('span', 'heromarks');
        var mlist = [];
        var s = soc(i);
        if (s.urgency && UTAG[s.urgency]) mlist.push([UTAG[s.urgency], el('b', 'utag ' + s.urgency, UTAG[s.urgency])]);
        if ((s.bundles_today || 0) >= 8) {
          var ctext = fill(S('chip_counter', 'In {n} bundles today'), { n: s.bundles_today });
          mlist.push([ctext, el('b', 'cntpill', ctext)]);
        }
        mlist.sort(function (a, b) { return b[0].length - a[0].length; });
        mlist.forEach(function (m) { marks.appendChild(m[1]); });
        main.appendChild(marks);
        pg.appendChild(main);

        // thumbs gallery — arrow-scrollable strip
        var gal = el('div', 'qv-gal');
        var galL = el('button', 'qv-galarr', '‹'); galL.type = 'button';
        galL.setAttribute('aria-hidden', 'true'); galL.tabIndex = -1;
        var galR = el('button', 'qv-galarr', '›'); galR.type = 'button';
        galR.setAttribute('aria-hidden', 'true'); galR.tabIndex = -1;
        var thumbs = el('div', 'qv-thumbs');
        galL.addEventListener('click', function (e) {
          e.stopPropagation();
          thumbs.scrollBy({ left: -180, behavior: 'smooth' });
        });
        galR.addEventListener('click', function (e) {
          e.stopPropagation();
          thumbs.scrollBy({ left: 180, behavior: 'smooth' });
        });
        designs[i].images.forEach(function (src, ti) {
          var th = el('img', 'qv-th' + (ti === 0 ? ' on' : ''));
          th.loading = 'lazy';
          th.alt = '';
          th.src = src;
          th.addEventListener('click', function (e) {
            e.stopPropagation();
            hero.src = src;
            var on = thumbs.querySelector('.on');
            if (on) on.classList.remove('on');
            th.classList.add('on');
          });
          thumbs.appendChild(th);
        });
        if (designs[i].images.length > 1) {
          gal.appendChild(galL);
          gal.appendChild(thumbs);
          gal.appendChild(galR);
        }
        pg.appendChild(gal);

        var txt = el('div', 'qv-txt');
        var qtitle = el('p', 'qv-title');
        if (s.rating) {
          var qstar = el('b', 'occhip starpill tstar');
          qstar.appendChild(el('i', null, '★'));
          qstar.appendChild(d.createTextNode(' ' + s.rating));
          qtitle.appendChild(qstar);
        }
        qtitle.appendChild(d.createTextNode(shortName(i)));   // size suffix dropped (Tyler)
        txt.appendChild(qtitle);
        /* every design carries the same 4 occasions — only the ORDER (their
           strength rank) differs, so the full list read identically on every
           card. Two strongest only (Tyler: "fix the loved for tags"). */
        var occ = soc(i).occasions;
        if (occ && occ.length) {
          var occr = el('div', 'qv-occr');
          occr.appendChild(el('span', 'occlbl', S('occ_loved', 'Loved for')));
          occ.slice(0, 2).forEach(function (o) { occr.appendChild(el('b', 'occhip socl', occName(o))); });
          txt.appendChild(occr);
        }
        pg.appendChild(txt);
        var act = el('div', 'qv-act tinder');
        var tx = el('button', 'tx', S('remove_word', 'Remove')); tx.type = 'button';
        tx.setAttribute('aria-label', fill(S('a11y_fewer', 'One fewer {name}'), { name: shortName(i) }));
        var mid = el('span', 'qv-mid');
        var tv = el('button', 'tv', S('add_word', 'Add')); tv.type = 'button';
        tv.setAttribute('aria-label', fill(S('a11y_more', 'One more {name}'), { name: shortName(i) }));
        act.appendChild(tx); act.appendChild(mid); act.appendChild(tv);
        pg.appendChild(act);
        tx.addEventListener('click', function (e) { e.stopPropagation(); if (opts.canRemove(i)) opts.onRemove(i, tx); syncAll(); });
        tv.addEventListener('click', function (e) {
          e.stopPropagation();
          if (!designs[i].available || !opts.canAdd()) return;
          var before = opts.total();
          var wasNew = opts.cnt(i) === 0;
          opts.onAdd(i);
          syncAll();
          if (opts.total() > before && wasNew && pageIndex() < ORDER.length - 1) {
            setTimeout(function () { glide(pagesEl, (pageIndex() + 1) * step(), 320, syncPos); }, 350);
          }
        });
        pageEls[i] = pg;
        pagesEl.appendChild(pg);
      });
    }
    buildPages();

    function syncPos() {
      var idx = pageIndex();
      navLbl.textContent = (idx + 1) + ' ' + S('of_word', 'of') + ' ' + ORDER.length;
      navL.disabled = idx <= 0;
      navR.disabled = idx >= ORDER.length - 1;
    }
    pagesEl.addEventListener('scroll', function () { clearTimeout(pagesEl._st); pagesEl._st = setTimeout(syncPos, 80); });
    navL.addEventListener('click', function () { glide(pagesEl, (pageIndex() - 1) * step(), 300, syncPos); });
    navR.addEventListener('click', function () { glide(pagesEl, (pageIndex() + 1) * step(), 300, syncPos); });

    function syncActs() {
      ORDER.forEach(function (i) {
        var pg = pageEls[i];
        if (!pg) return;
        var n = opts.cnt(i);
        pg.classList.toggle('in', n > 0);
        var mid = pg.querySelector('.qv-mid');
        var tx = pg.querySelector('.tx'), tv = pg.querySelector('.tv');
        tx.disabled = !(n > 0 && opts.canRemove(i));
        tv.disabled = !designs[i].available || !opts.canAdd();
        if (!designs[i].available) mid.textContent = S('sold_out', 'Sold out');
        else if (n > 0) mid.textContent = '×' + n + ' ' + S('qv_in_bundle', 'in your bundle');
        else mid.textContent = fill(S('qv_add_price', 'Add · {price}'), { price: money(opts.nextUnitPrice(i)) });
      });
    }
    function syncFoot() {
      var pr = opts.progress();
      footDots.textContent = '';
      var sd2 = slotDots(pr.q, pr.cap, { plain: true });
      while (sd2.firstChild) footDots.appendChild(sd2.firstChild);
      // mirror the widget's own nudge — with its own ticker
      var wn = opts.lowerHost.nudge;
      footNudge.innerHTML = wn.innerHTML;
      footNudge.classList.toggle('gold', wn.classList.contains('gold'));
      footNudge.classList.toggle('jackpot', wn.classList.contains('jackpot'));
      var sEl = footNudge.querySelector('.nscore');
      if (sEl) {
        var b = sEl.querySelector('b');
        tickMoney(b, footNudge._pv || 0, opts.lowerHost.nudge._pv || 0);
        footNudge._pv = opts.lowerHost.nudge._pv || 0;
      } else footNudge._pv = 0;
      footShip.innerHTML = opts.lowerHost.ship.innerHTML;
      footAtc.textContent = opts.atcLabel();
      /* mirror the receipt DOM like the ship line above it — the string hook
         couldn't carry 1B's rows, and one source keeps the two panels exact */
      footSum.innerHTML = opts.lowerHost.sum.innerHTML;
      footSum.hidden = opts.lowerHost.sum.hidden;
      footAtc.disabled = opts.total() === 0;
    }
    footAtc.addEventListener('click', function () { close(); opts.onAtc(); });
    function syncAll() { syncActs(); syncFoot(); syncPos(); }

    function open(i) {
      root.style.minHeight = root.offsetHeight + 'px';   // no page jump on swap
      root.classList.add('qv-open');
      qv.hidden = false;
      openState = true;
      void pagesEl.offsetWidth;                          // position synchronously
      pagesEl.scrollLeft = ORDER.indexOf(i) * step();
      syncAll();
      if (isPhone()) {
        /* the view starts exactly at the Back button */
        var r = backBtn.getBoundingClientRect();
        try { w.scrollBy({ top: r.top - 8, left: 0 }); }
        catch (e) { w.scrollBy(0, r.top - 8); }
      }
      d.addEventListener('keydown', onKey);
      try { backBtn.focus(); } catch (e) {}
      emit('bundle_browse_open', { product_id: designs[i].product_id }, { variant: VARIANT });
    }
    function close() {
      qv.hidden = true;
      openState = false;
      root.classList.remove('qv-open');
      root.style.minHeight = '';
      d.removeEventListener('keydown', onKey);
    }
    function onKey(e) {
      if (e.key === 'Escape') close();
      if (e.key === 'ArrowRight') navR.click();
      if (e.key === 'ArrowLeft') navL.click();
    }
    backBtn.addEventListener('click', close);
    return {
      open: open,
      sync: syncAll,
      syncIfOpen: function () { if (openState) syncAll(); }
    };
  }

  // ───────────────────────── boot ─────────────────────────
  host.hidden = false;
  /* The widget owns purchase on this page — retire the theme's native buy UI
     exactly as the Kaching embed did. Includes the custom ADD TO BAG whose
     price span (.price_quan) a theme helper used to fill from Kaching's bar:
     with Kaching disabled it writes "No price found" into a button nobody
     should be seeing. Display:none, not removal — rollback-safe. */
  try {
    var killList = [];
    var natives = d.querySelectorAll('.product-form__buttons, .product-form__quantity');
    for (var ni = 0; ni < natives.length; ni++) {
      if (!host.contains(natives[ni])) killList.push(natives[ni]);
    }
    var pq = d.querySelector('.price_quan');
    if (pq) {
      var pqBtn = pq.closest('button, a, .product-form__buttons');
      if (pqBtn && !host.contains(pqBtn)) killList.push(pqBtn);
    }
    for (var ki = 0; ki < killList.length; ki++) killList[ki].style.display = 'none';
  } catch (e) {}
  host.classList.add('pp-bundle--' + VARIANT);
  var inner = el('div', 'w');
  host.appendChild(inner);
  if (VARIANT === 'b2') widgetB2(inner); else widgetB1(inner);
  emit('bundle_view', { product_id: CFG.anchor.product_id }, {
    variant: VARIANT, ladder: CFG.ladder_collection
  });
})(window, document);
